import React from 'react';
import { useHistory } from 'react-router-dom';
import {
  CONSENT_TO_TEST_V4_KEY,
  ConsentAppForm,
  FINANCIAL_ASSISTANCE_FORM_V5_KEY,
} from '@tempus/patient-forms-service-shared';

import NavigatorChecklist from './NavigatorChecklist';

// TODO: get this from patient-forms-service
const STANDALONE_FORM_LIST: ConsentAppForm[] = [
  {
    key: FINANCIAL_ASSISTANCE_FORM_V5_KEY,
    title: 'Financial Assistance',
    description:
      'Tempus has a Financial Assistance Program to help provide access to our tests for patients in financial need. Approval of the financial assistance application is based on your household income and takes into account relevant life circumstances.',
    link: 'financial-assistance',
    required: false,
    complete: false,
  },
  {
    key: CONSENT_TO_TEST_V4_KEY,
    title: 'Consent to Testing',
    description:
      'This document provides your consent for Tempus to run the test(s) your doctor ordered, bill your insurance, and use your specimens and health information. If you are an oncology patient in NY, OR, AK, CA, FL, GA, MN, NE, TX or your doctor asks you to sign, please return a signed copy to Tempus.',
    link: 'consent-to-test',
    required: false,
    complete: false,
  },
  {
    key: 'HIPAA_AUTHORIZATION_V3',
    title: 'Notice and Authorization for Health Records',
    description:
      'Tempus is working to make precision medicine a reality for patients. Please complete this form if you are interested in helping us with that mission.',
    link: 'hipaa-authorization',
    required: false,
    complete: false,
  },
];

const CustomToDoListRoot: React.FunctionComponent = () => {
  const history = useHistory();
  return <NavigatorChecklist formList={STANDALONE_FORM_LIST} history={history} isStandalone />;
};

export default CustomToDoListRoot;
